<template>
  <div class="section-news">
    <div class="section-news-content">
      <h3>新闻中心</h3>
      <ul>
        <li v-for="(item, index) in homeList" :key="index">
          <div class="section-news-content-left">
            <p class="section-news-content-month">{{ item.day }}</p>
            <p class="section-news-content-year">{{ item.year }}/{{ item.month }}</p>
          </div>
          <div class="section-news-content-right" @click="goNewsDetail(item)">
            <h5 class="section-news-content-title">
              <a target="_blank">{{ item.title }}</a>
            </h5>
            <p class="section-news-content-detail">
              <a
                target="_blank"
                class="section-news-content-detail-item"
                v-html="item.subTitle"
              ></a>
            </p>
          </div>
        </li>
      </ul>
      <p class="section-news-content-btn">
        <!-- <a href="/weAbout">查看更多</a> -->
        <el-pagination background layout="prev, pager, next" :page-size="4"  :total="total" @current-change="changePage" >
        </el-pagination>
      </p>
    </div>
  </div>
</template>

<script>
import { getArticleList } from '@/api/home'
export default {
  data () {
    return {
      newsList: [
        {
          title: '发展金融科技能力，好分期为提振消费提供新引擎',
          year: '2020',
          month: '07',
          day: '24',
          newUpdateDate: '2020年07月24日',
          source: '网易财经',
          subTitle:
            '疫情防控常态化背景下，消费成为经济增长的主要抓手之一。在多项促消费政策支持下，一季度被压抑的消费需求稳步释放，消费金融迎来政策鼓励与市场回暖的双重利好。',
          link: 'https://mp.weixin.qq.com/s/QYmEWjhjotpYkFvavYDs-g',
          pictureUrl: '@/assets/images/weicai/about-1.png',
          articleType: 'link'
        },
        {
          title: 'beat365手机版官网厦门获融资担保牌照，全牌照布局又进一步',
          year: '2020',
          month: '07',
          day: '01',
          newUpdateDate: '2020年07月01日',
          source: '中国经营网',
          subTitle:
            'beat365手机版官网注册成立厦门beat365手机版官网融资担保有限公司，注册资本1亿元人民币。此番获得融资担保牌照后，beat365手机版官网的牌照布局将更加全面。',
          link: 'https://mp.weixin.qq.com/s/8egmEFHWxj9R6AQrasCe6Q',
          pictureUrl: '@/assets/images/weicai/about-2.png',
          articleType: 'link'
        },
        {
          title: '中国营销40年，企业大考再次来临。快速变化的市场，年，企业大考再次来临。快速变化的市场，层出不穷层出不穷的新工具',
          year: '2020',
          month: '06',
          day: '24',
          newUpdateDate: '2020年06月24日',
          source: '网易财经',
          subTitle:
            '政策导向下，金融科技发展空间将进一步增大。好分期也将以高效的消费金融服务，支撑经济高质量发展。',
          link: 'https://mp.weixin.qq.com/s/RGwrxSzIniyJFbXZAama_A',
          pictureUrl: '@/assets/images/weicai/about-3.png',
          articleType: 'link'
        },
        {
          title: '北京鼓励金融科技规范创新，beat365手机版官网旗下好分期迎机遇',
          year: '2020',
          month: '06',
          day: '24',
          newUpdateDate: '2020年06月24日',
          source: '网易财经',
          subTitle:
            '政策导向下，金融科技发展空间将进一步增大。好分期也将以高效的消费金融服务，支撑经济高质量发展。',
          link: 'https://mp.weixin.qq.com/s/RGwrxSzIniyJFbXZAama_A',
          pictureUrl: '@/assets/images/weicai/about-3.png',
          articleType: 'link'
        },
        {
          title: '好分期以高效消费金融服务支持消费复苏',
          year: '2020',
          month: '06',
          day: '18',
          newUpdateDate: '2020年06月18日',
          source: '财经网',
          subTitle:
            '疫情发生期间，好分期力保障线上金融服务力度不减，利用金融科技手段，在疫情引发的线下向线上活动迁移的过程中，全面提升线上客户服务效率，保障每一位客户的需求能得到及时响应。',
          link: 'https://mp.weixin.qq.com/s/FChzYrKIpuQjIhlm1DVVPQ',
          pictureUrl: '@/assets/images/weicai/about-4.png',
          articleType: 'link'
        },
        {
          title: '好分期依托智能风控技术，紧抓消费潮流新趋势',
          year: '2020',
          month: '06',
          day: '18',
          newUpdateDate: '2020年06月18日',
          source: '北青网财经',
          subTitle:
            '好分期通过对大数据、人工智能技术的应用，实现了更精准、高效的风险甄别。建立起贯穿整个用户生命周期的大数据风控系统，形成“大数据-建模-大数据”的闭环，实现了系统自动化和智能化。',
          link: 'https://mp.weixin.qq.com/s/E33i59gnssAPfaZbQoKMKw',
          pictureUrl: '@/assets/images/weicai/about-5.png',
          articleType: 'link'
        },
        {
          title: '好分期实现跨越式增长，成为消费分期黑马',
          year: '2020',
          month: '06',
          day: '17',
          newUpdateDate: '2020年06月17日',
          source: '金融界',
          subTitle:
            '好分期历经2年时间在消费分期领域中脱颖而出，获得广大高成长性年轻用户的认可。在互联网行业流量增长瓶颈的情况下，好分期依托数据营销能力实现用户量级的指数级增长。',
          link: 'https://mp.weixin.qq.com/s/BtEeQk9S05chc1MsTp5SXA',
          pictureUrl: '@/assets/images/weicai/about-6.png',
          articleType: 'link'
        },
        {
          title: '发展金融科技能力，好分期为提振消费提供新引擎',
          year: '2020',
          month: '07',
          day: '24',
          newUpdateDate: '2020年07月24日',
          source: '网易财经',
          subTitle:
            '疫情防控常态化背景下，消费成为经济增长的主要抓手之一。在多项促消费政策支持下，一季度被压抑的消费需求稳步释放，消费金融迎来政策鼓励与市场回暖的双重利好。',
          link: 'https://mp.weixin.qq.com/s/QYmEWjhjotpYkFvavYDs-g',
          pictureUrl: '@/assets/images/weicai/about-1.png',
          articleType: 'link'
        },
        {
          title: 'beat365手机版官网厦门获融资担保牌照，全牌照布局又进一步',
          year: '2020',
          month: '07',
          day: '01',
          newUpdateDate: '2020年07月01日',
          source: '中国经营网',
          subTitle:
            'beat365手机版官网注册成立厦门beat365手机版官网融资担保有限公司，注册资本1亿元人民币。此番获得融资担保牌照后，beat365手机版官网的牌照布局将更加全面。',
          link: 'https://mp.weixin.qq.com/s/8egmEFHWxj9R6AQrasCe6Q',
          pictureUrl: '@/assets/images/weicai/about-2.png',
          articleType: 'link'
        },
        {
          title: '中国营销40年，企业大考再次来临。快速变化的市场，年，企业大考再次来临。快速变化的市场，层出不穷层出不穷的新工具',
          year: '2020',
          month: '06',
          day: '24',
          newUpdateDate: '2020年06月24日',
          source: '网易财经',
          subTitle:
            '政策导向下，金融科技发展空间将进一步增大。好分期也将以高效的消费金融服务，支撑经济高质量发展。',
          link: 'https://mp.weixin.qq.com/s/RGwrxSzIniyJFbXZAama_A',
          pictureUrl: '@/assets/images/weicai/about-3.png',
          articleType: 'link'
        },
        {
          title: '北京鼓励金融科技规范创新，beat365手机版官网旗下好分期迎机遇',
          year: '2020',
          month: '06',
          day: '24',
          newUpdateDate: '2020年06月24日',
          source: '网易财经',
          subTitle:
            '政策导向下，金融科技发展空间将进一步增大。好分期也将以高效的消费金融服务，支撑经济高质量发展。',
          link: 'https://mp.weixin.qq.com/s/RGwrxSzIniyJFbXZAama_A',
          pictureUrl: '@/assets/images/weicai/about-3.png',
          articleType: 'link'
        },
        {
          title: '好分期以高效消费金融服务支持消费复苏',
          year: '2020',
          month: '06',
          day: '18',
          newUpdateDate: '2020年06月18日',
          source: '财经网',
          subTitle:
            '疫情发生期间，好分期力保障线上金融服务力度不减，利用金融科技手段，在疫情引发的线下向线上活动迁移的过程中，全面提升线上客户服务效率，保障每一位客户的需求能得到及时响应。',
          link: 'https://mp.weixin.qq.com/s/FChzYrKIpuQjIhlm1DVVPQ',
          pictureUrl: '@/assets/images/weicai/about-4.png',
          articleType: 'link'
        },
        {
          title: '好分期依托智能风控技术，紧抓消费潮流新趋势',
          year: '2020',
          month: '06',
          day: '18',
          newUpdateDate: '2020年06月18日',
          source: '北青网财经',
          subTitle:
            '好分期通过对大数据、人工智能技术的应用，实现了更精准、高效的风险甄别。建立起贯穿整个用户生命周期的大数据风控系统，形成“大数据-建模-大数据”的闭环，实现了系统自动化和智能化。',
          link: 'https://mp.weixin.qq.com/s/E33i59gnssAPfaZbQoKMKw',
          pictureUrl: '@/assets/images/weicai/about-5.png',
          articleType: 'link'
        },
        {
          title: '发展金融科技能力，好分期为提振消费提供新引擎',
          year: '2020',
          month: '07',
          day: '24',
          newUpdateDate: '2020年07月24日',
          source: '网易财经',
          subTitle:
            '疫情防控常态化背景下，消费成为经济增长的主要抓手之一。在多项促消费政策支持下，一季度被压抑的消费需求稳步释放，消费金融迎来政策鼓励与市场回暖的双重利好。',
          link: 'https://mp.weixin.qq.com/s/QYmEWjhjotpYkFvavYDs-g',
          pictureUrl: '@/assets/images/weicai/about-1.png',
          articleType: 'link'
        },
        {
          title: 'beat365手机版官网厦门获融资担保牌照，全牌照布局又进一步',
          year: '2020',
          month: '07',
          day: '01',
          newUpdateDate: '2020年07月01日',
          source: '中国经营网',
          subTitle:
            'beat365手机版官网注册成立厦门beat365手机版官网融资担保有限公司，注册资本1亿元人民币。此番获得融资担保牌照后，beat365手机版官网的牌照布局将更加全面。',
          link: 'https://mp.weixin.qq.com/s/8egmEFHWxj9R6AQrasCe6Q',
          pictureUrl: '@/assets/images/weicai/about-2.png',
          articleType: 'link'
        },
        {
          title: '中国营销40年，企业大考再次来临。快速变化的市场，年，企业大考再次来临。快速变化的市场，层出不穷层出不穷的新工具',
          year: '2020',
          month: '06',
          day: '24',
          newUpdateDate: '2020年06月24日',
          source: '网易财经',
          subTitle:
            '政策导向下，金融科技发展空间将进一步增大。好分期也将以高效的消费金融服务，支撑经济高质量发展。',
          link: 'https://mp.weixin.qq.com/s/RGwrxSzIniyJFbXZAama_A',
          pictureUrl: '@/assets/images/weicai/about-3.png',
          articleType: 'link'
        },
        {
          title: '北京鼓励金融科技规范创新，beat365手机版官网旗下好分期迎机遇',
          year: '2020',
          month: '06',
          day: '24',
          newUpdateDate: '2020年06月24日',
          source: '网易财经',
          subTitle:
            '政策导向下，金融科技发展空间将进一步增大。好分期也将以高效的消费金融服务，支撑经济高质量发展。',
          link: 'https://mp.weixin.qq.com/s/RGwrxSzIniyJFbXZAama_A',
          pictureUrl: '@/assets/images/weicai/about-3.png',
          articleType: 'link'
        },
        {
          title: '好分期以高效消费金融服务支持消费复苏',
          year: '2020',
          month: '06',
          day: '18',
          newUpdateDate: '2020年06月18日',
          source: '财经网',
          subTitle:
            '疫情发生期间，好分期力保障线上金融服务力度不减，利用金融科技手段，在疫情引发的线下向线上活动迁移的过程中，全面提升线上客户服务效率，保障每一位客户的需求能得到及时响应。',
          link: 'https://mp.weixin.qq.com/s/FChzYrKIpuQjIhlm1DVVPQ',
          pictureUrl: '@/assets/images/weicai/about-4.png',
          articleType: 'link'
        },
        {
          title: '好分期依托智能风控技术，紧抓消费潮流新趋势',
          year: '2020',
          month: '06',
          day: '18',
          newUpdateDate: '2020年06月18日',
          source: '北青网财经',
          subTitle:
            '好分期通过对大数据、人工智能技术的应用，实现了更精准、高效的风险甄别。建立起贯穿整个用户生命周期的大数据风控系统，形成“大数据-建模-大数据”的闭环，实现了系统自动化和智能化。',
          link: 'https://mp.weixin.qq.com/s/E33i59gnssAPfaZbQoKMKw',
          pictureUrl: '@/assets/images/weicai/about-5.png',
          articleType: 'link'
        },
        {
          title: '发展金融科技能力，好分期为提振消费提供新引擎',
          year: '2020',
          month: '07',
          day: '24',
          newUpdateDate: '2020年07月24日',
          source: '网易财经',
          subTitle:
            '疫情防控常态化背景下，消费成为经济增长的主要抓手之一。在多项促消费政策支持下，一季度被压抑的消费需求稳步释放，消费金融迎来政策鼓励与市场回暖的双重利好。',
          link: 'https://mp.weixin.qq.com/s/QYmEWjhjotpYkFvavYDs-g',
          pictureUrl: '@/assets/images/weicai/about-1.png',
          articleType: 'link'
        },
        {
          title: 'beat365手机版官网厦门获融资担保牌照，全牌照布局又进一步',
          year: '2020',
          month: '07',
          day: '01',
          newUpdateDate: '2020年07月01日',
          source: '中国经营网',
          subTitle:
            'beat365手机版官网注册成立厦门beat365手机版官网融资担保有限公司，注册资本1亿元人民币。此番获得融资担保牌照后，beat365手机版官网的牌照布局将更加全面。',
          link: 'https://mp.weixin.qq.com/s/8egmEFHWxj9R6AQrasCe6Q',
          pictureUrl: '@/assets/images/weicai/about-2.png',
          articleType: 'link'
        },
        {
          title: '中国营销40年，企业大考再次来临。快速变化的市场，年，企业大考再次来临。快速变化的市场，层出不穷层出不穷的新工具',
          year: '2020',
          month: '06',
          day: '24',
          newUpdateDate: '2020年06月24日',
          source: '网易财经',
          subTitle:
            '政策导向下，金融科技发展空间将进一步增大。好分期也将以高效的消费金融服务，支撑经济高质量发展。',
          link: 'https://mp.weixin.qq.com/s/RGwrxSzIniyJFbXZAama_A',
          pictureUrl: '@/assets/images/weicai/about-3.png',
          articleType: 'link'
        },
        {
          title: '北京鼓励金融科技规范创新，beat365手机版官网旗下好分期迎机遇',
          year: '2020',
          month: '06',
          day: '24',
          newUpdateDate: '2020年06月24日',
          source: '网易财经',
          subTitle:
            '政策导向下，金融科技发展空间将进一步增大。好分期也将以高效的消费金融服务，支撑经济高质量发展。',
          link: 'https://mp.weixin.qq.com/s/RGwrxSzIniyJFbXZAama_A',
          pictureUrl: '@/assets/images/weicai/about-3.png',
          articleType: 'link'
        },
        {
          title: '好分期以高效消费金融服务支持消费复苏',
          year: '2020',
          month: '06',
          day: '18',
          newUpdateDate: '2020年06月18日',
          source: '财经网',
          subTitle:
            '疫情发生期间，好分期力保障线上金融服务力度不减，利用金融科技手段，在疫情引发的线下向线上活动迁移的过程中，全面提升线上客户服务效率，保障每一位客户的需求能得到及时响应。',
          link: 'https://mp.weixin.qq.com/s/FChzYrKIpuQjIhlm1DVVPQ',
          pictureUrl: '@/assets/images/weicai/about-4.png',
          articleType: 'link'
        },
        {
          title: '好分期依托智能风控技术，紧抓消费潮流新趋势',
          year: '2020',
          month: '06',
          day: '18',
          newUpdateDate: '2020年06月18日',
          source: '北青网财经',
          subTitle:
            '好分期通过对大数据、人工智能技术的应用，实现了更精准、高效的风险甄别。建立起贯穿整个用户生命周期的大数据风控系统，形成“大数据-建模-大数据”的闭环，实现了系统自动化和智能化。',
          link: 'https://mp.weixin.qq.com/s/E33i59gnssAPfaZbQoKMKw',
          pictureUrl: '@/assets/images/weicai/about-5.png',
          articleType: 'link'
        },
        {
          title: '发展金融科技能力，好分期为提振消费提供新引擎',
          year: '2020',
          month: '07',
          day: '24',
          newUpdateDate: '2020年07月24日',
          source: '网易财经',
          subTitle:
            '疫情防控常态化背景下，消费成为经济增长的主要抓手之一。在多项促消费政策支持下，一季度被压抑的消费需求稳步释放，消费金融迎来政策鼓励与市场回暖的双重利好。',
          link: 'https://mp.weixin.qq.com/s/QYmEWjhjotpYkFvavYDs-g',
          pictureUrl: '@/assets/images/weicai/about-1.png',
          articleType: 'link'
        },
        {
          title: 'beat365手机版官网厦门获融资担保牌照，全牌照布局又进一步',
          year: '2020',
          month: '07',
          day: '01',
          newUpdateDate: '2020年07月01日',
          source: '中国经营网',
          subTitle:
            'beat365手机版官网注册成立厦门beat365手机版官网融资担保有限公司，注册资本1亿元人民币。此番获得融资担保牌照后，beat365手机版官网的牌照布局将更加全面。',
          link: 'https://mp.weixin.qq.com/s/8egmEFHWxj9R6AQrasCe6Q',
          pictureUrl: '@/assets/images/weicai/about-2.png',
          articleType: 'link'
        },
        {
          title: '中国营销40年，企业大考再次来临。快速变化的市场，年，企业大考再次来临。快速变化的市场，层出不穷层出不穷的新工具',
          year: '2020',
          month: '06',
          day: '24',
          newUpdateDate: '2020年06月24日',
          source: '网易财经',
          subTitle:
            '政策导向下，金融科技发展空间将进一步增大。好分期也将以高效的消费金融服务，支撑经济高质量发展。',
          link: 'https://mp.weixin.qq.com/s/RGwrxSzIniyJFbXZAama_A',
          pictureUrl: '@/assets/images/weicai/about-3.png',
          articleType: 'link'
        },
        {
          title: '北京鼓励金融科技规范创新，beat365手机版官网旗下好分期迎机遇',
          year: '2020',
          month: '06',
          day: '24',
          newUpdateDate: '2020年06月24日',
          source: '网易财经',
          subTitle:
            '政策导向下，金融科技发展空间将进一步增大。好分期也将以高效的消费金融服务，支撑经济高质量发展。',
          link: 'https://mp.weixin.qq.com/s/RGwrxSzIniyJFbXZAama_A',
          pictureUrl: '@/assets/images/weicai/about-3.png',
          articleType: 'link'
        },
        {
          title: '好分期以高效消费金融服务支持消费复苏',
          year: '2020',
          month: '06',
          day: '18',
          newUpdateDate: '2020年06月18日',
          source: '财经网',
          subTitle:
            '疫情发生期间，好分期力保障线上金融服务力度不减，利用金融科技手段，在疫情引发的线下向线上活动迁移的过程中，全面提升线上客户服务效率，保障每一位客户的需求能得到及时响应。',
          link: 'https://mp.weixin.qq.com/s/FChzYrKIpuQjIhlm1DVVPQ',
          pictureUrl: '@/assets/images/weicai/about-4.png',
          articleType: 'link'
        },
        {
          title: '好分期依托智能风控技术，紧抓消费潮流新趋势',
          year: '2020',
          month: '06',
          day: '18',
          newUpdateDate: '2020年06月18日',
          source: '北青网财经',
          subTitle:
            '好分期通过对大数据、人工智能技术的应用，实现了更精准、高效的风险甄别。建立起贯穿整个用户生命周期的大数据风控系统，形成“大数据-建模-大数据”的闭环，实现了系统自动化和智能化。',
          link: 'https://mp.weixin.qq.com/s/E33i59gnssAPfaZbQoKMKw',
          pictureUrl: '@/assets/images/weicai/about-5.png',
          articleType: 'link'
        },
      ],
      homeList: [],
      reportList: [],
      newsTotalList: [],
      totalPage: 6,
      count: 1,
      isShow: true,
      total: 30,
    }
  },
  mounted () {
    this.getArticleList()
  },
  methods: {
    getArticleList: function () {
      var _this = this
      var params = {
        category: 'news_center'
      }
      getArticleList(params)
        .then((res) => {
          if (res.code === 0 && res.data.list && res.data.list.length > 0) {
            _this.newsTotalList = res.data.list
            _this.total = res.data.total
            _this.newsTotalList.forEach(function (item) {
              var regList = /^(\d{4})-(\d{2})-(\d{2})/.exec(item.updateDate)
              item.year = regList[1]
              item.month = regList[2]
              item.day = regList[3]
              item.newUpdateDate = item.year + '年' + item.month + '月' + item.day + '日'
            })
          } else {
            _this.newsTotalList = _this.newsList
          }
          _this.reportList = _this.getShowList(6)
          _this.isShow = _this.totalPage > 6
          _this.homeList = _this.getShowList(4)
        })
        .catch(() => {
          _this.newsTotalList = _this.newsList
          _this.reportList = _this.getShowList(6)
          _this.homeList = _this.getShowList(4)
        })
    },
    getShowList: function (pageSize) {
      return this.newsTotalList.slice(0, pageSize * this.count)
    },
    changePage: function(page){
      this.homeList = this.newsTotalList.slice((page-1)*4, page*4)
    },
    goNewsDetail (row) {
      if (row.articleType === 'link') {
        location.href = row.link
      } else {
        this.$router.push({
          path: '/WeNewsDetail',
          query: {
            newsId: row._id
          }
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.section-news {
  background-color: #F4F5F9;
  padding-bottom: 96px;
  h3 {
    padding-top: 80px;
    padding-bottom: 72px;
    letter-spacing: 0;
    text-align: center;
    height: 30px;
    font-size: 30px;
    color: #000000;
    line-height: 30px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
  }
  &-content {
    margin: 0 auto;
    width: 1080px;
    ul {
      overflow: hidden;
    }
    li {
      height: 120px;
      margin-bottom: 20px;
      float: left;
      cursor: pointer;
      &:nth-child(even) {
        float: right;
      }
    }
    div {
      float: left;
    }
    &-left {
      margin-right: 23px;
      position: relative;
      // top: -7px;
    }
    &-month {
      height: 36px;
      font-size: 46px;
      font-family: DINPro-Medium, DINPro;
      font-weight: 500;
      color: #004bb3;
      line-height: 36px;
    }
    &-year {
      height: 18px;
      margin-top: 7px;
      font-size: 14px;
      font-family: DINPro-Regular, DINPro;
      font-weight: 400;
      color: #2e2e33;
      line-height: 18px;
    }
    &-line {
      font-size: 20px;
    }
    &-title {
      position: relative;
      margin-bottom: 16px;
      font-size: 18px;
      color: rgba(46, 46, 51, 1);
      width: 390px;
      line-height: 24px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      max-height: 48px;
      a {
        color: rgba(46, 46, 51, 1);
      }
      &:hover {
        a {
          color: rgba(0, 75, 179, 1);
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
    }
    &-detail {
      width: 390px;
      font-size: 14px;
      color: rgba(145, 145, 153, 1);
      line-height: 24px;
      height: 48px;
      overflow: hidden;
      &:hover {
        a {
          color: rgba(145, 145, 153, 1);
        }
      }
    }
    &-detail-item {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      color: #919199;
    }
    &-btn {
      padding: 0 auto 96px;
      width: auto;
      border-radius: 4px;
      text-align: center;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
      line-height: 19px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      position: relative;
      top: 30px;
      // a {
      //   display: inline-block;
      //   position: relative;
      //   height: 19px;
      //   font-size: 16px;
      //   font-family: PingFangSC-Medium, PingFang SC;
      //   font-weight: 500;
      //   color: #000000;
      //   line-height: 19px;
      //   &::after{
      //     content: '';
      //     position: absolute;
      //     top: 3px;
      //     right: -18px;
      //     width: 12px;
      //     height: 12px;
      //     background: url(../assets/images/weicai/home/more.png) no-repeat;
      //     background-size: contain;
      //   }
      // }
    }
  }
}

/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
  background: #1468DD ;
}
</style>



// WEBPACK FOOTER //
// src/components/newsList.vue